import { render } from "./Abrechnung.vue?vue&type=template&id=e6ef5130"
import script from "./Abrechnung.vue?vue&type=script&lang=js"
export * from "./Abrechnung.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__